export default "__VITE_ASSET__DGXxmU0D__"